export default __webpack_public_path__ + "static/media/placeholder_private01-fr-web.582bad10.png";